/* =================================================================
   SCIENTIST LAB — product.js  (PDP: variants, swipe gallery, ATC)
   ================================================================= */
(function () {
  "use strict";

  var root = document.querySelector("[data-pdp]");
  if (!root) return;

  var S = window.SLshop || { moneyFormat: "{{amount}} €" };
  function money(cents) {
    var fmt = S.moneyFormat || "{{amount}} €";
    var v = (cents / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1");
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  function norm(src) {
    if (!src) return "";
    return src.split("?")[0].replace(/_\d+x\d*(\.[a-z]+)$/i, "$1");
  }

  var variants = [];
  var mediaList = [];
  try { variants = JSON.parse(root.querySelector("[data-product-variants]").textContent); } catch (e) {}
  try { mediaList = JSON.parse(root.querySelector("[data-product-media]").textContent); } catch (e) {}

  var idInput = root.querySelector("[data-variant-id]");
  var priceEl = root.querySelector("[data-pdp-price]");
  var addBtn = root.querySelector("[data-pdp-add]");
  var qtyInput = root.querySelector("[data-qty-input]");
  var mainImg = root.querySelector("[data-main]");
  var stockEl = root.querySelector("[data-stock]");
  var barPrice = document.querySelector("[data-bar-price]");
  var cmpEl = root.querySelector("[data-pdp-compare]");
  var barCmp = document.querySelector("[data-bar-compare]");

  var selected = [null, null, null];
  /* initialise from active buttons */
  root.querySelectorAll("[data-option-block]").forEach(function (block) {
    var idx = parseInt(block.dataset.optionBlock, 10);
    var act = block.querySelector(".active[data-option-index]");
    if (act) selected[idx] = act.dataset.value;
  });

  function currentVariant() {
    return variants.filter(function (v) {
      if (selected[0] != null && v.option1 !== selected[0]) return false;
      if (selected[1] != null && v.option2 !== selected[1]) return false;
      if (selected[2] != null && v.option3 !== selected[2]) return false;
      return true;
    })[0];
  }

  function setGalleryTo(src) {
    if (!src) return;
    if (mainImg) mainImg.src = src;
    var target = norm(src);
    var slides = root.querySelectorAll("[data-pdp-track] .pdp__slide");
    var track = root.querySelector("[data-pdp-track]");
    slides.forEach(function (sl, i) {
      var img = sl.querySelector("img");
      if (img && norm(img.src) === target && track) track.scrollLeft = track.clientWidth * i;
    });
    root.querySelectorAll(".pdp__thumb").forEach(function (th) {
      th.classList.toggle("active", norm(th.dataset.thumb) === target);
    });
  }

  function updateVariant() {
    var v = currentVariant();
    if (!v) return;
    if (idInput) idInput.value = v.id;
    var avail = v.available;
    if (priceEl) priceEl.textContent = money(v.price);
    if (barPrice) barPrice.textContent = money(v.price);
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    [cmpEl, barCmp].forEach(function (el) {
      if (!el) return;
      el.hidden = !onSale;
      if (onSale) el.textContent = money(v.compare_at_price);
    });
    if (priceEl) priceEl.classList.toggle("price-sale", !!onSale);
    if (addBtn) {
      addBtn.disabled = !avail;
      addBtn.textContent = avail ? ("AJOUTER · " + money(v.price * (parseInt(qtyInput && qtyInput.value, 10) || 1))) : "ÉPUISÉ";
    }
    if (stockEl) stockEl.textContent = avail ? "En stock — expédié sous 48h" : "Bientôt de retour";
    if (v.featured_image && v.featured_image.src) setGalleryTo(v.featured_image.src);
  }

  /* option selection */
  root.querySelectorAll("[data-option-index]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var idx = parseInt(btn.dataset.optionIndex, 10);
      selected[idx] = btn.dataset.value;
      var block = btn.closest("[data-option-block]");
      block.querySelectorAll("[data-option-index]").forEach(function (b) { b.classList.toggle("active", b === btn); });
      var sel = block.querySelector("[data-opt-sel]");
      if (sel) sel.textContent = btn.dataset.value;
      block.classList.remove("err");
      var msg = block.querySelector("[data-size-msg]");
      if (msg) msg.textContent = "";
      updateVariant();
    });
  });
  updateVariant();

  /* quantity */
  var qty = 1;
  var qtyVal = root.querySelector("[data-qty-val]");
  root.querySelector(".qty-step") && root.querySelector(".qty-step").addEventListener("click", function (e) {
    var b = e.target.closest("[data-qstep]");
    if (!b) return;
    qty = Math.max(1, qty + parseInt(b.dataset.qstep, 10));
    if (qtyVal) qtyVal.textContent = qty;
    if (qtyInput) qtyInput.value = qty;
    updateVariant();
  });

  /* add to cart (form submit + sticky bar) */
  function tryAdd(e) {
    if (e) e.preventDefault();
    var blocks = root.querySelectorAll("[data-option-block]");
    for (var i = 0; i < blocks.length; i++) {
      var idx = parseInt(blocks[i].dataset.optionBlock, 10);
      if (selected[idx] == null) {
        blocks[i].classList.add("err");
        var msg = blocks[i].querySelector("[data-size-msg]");
        if (msg) msg.textContent = "Sélectionne une option.";
        blocks[i].scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
    }
    var v = currentVariant();
    if (!v || !v.available) return;
    if (window.SL_addToCart) window.SL_addToCart(v.id, qty);
  }
  var form = document.getElementById("pdpForm");
  if (form) form.addEventListener("submit", tryAdd);
  var barAdd = document.querySelector("[data-bar-add]");
  if (barAdd) barAdd.addEventListener("click", tryAdd);

  /* gallery thumbs (desktop) */
  var thumbs = root.querySelector("[data-thumbs]");
  if (thumbs) thumbs.addEventListener("click", function (e) {
    var t = e.target.closest("[data-thumb]");
    if (!t) return;
    if (mainImg) mainImg.src = t.dataset.thumb;
    root.querySelectorAll(".pdp__thumb").forEach(function (b) { b.classList.toggle("active", b === t); });
  });

  /* mobile swipe gallery: dots + tap-to-zoom */
  var ptrack = root.querySelector("[data-pdp-track]");
  if (ptrack) {
    var pdots = root.querySelector("[data-pdp-dots]");
    ptrack.addEventListener("scroll", function () {
      if (!ptrack.clientWidth || !pdots) return;
      var i = Math.round(ptrack.scrollLeft / ptrack.clientWidth);
      Array.prototype.forEach.call(pdots.children, function (d, k) { d.classList.toggle("on", k === i); });
    });
    var psx = 0, psy = 0, pmoved = false;
    ptrack.addEventListener("pointerdown", function (e) { psx = e.clientX; psy = e.clientY; pmoved = false; });
    ptrack.addEventListener("pointermove", function (e) { if (Math.abs(e.clientX - psx) > 8 || Math.abs(e.clientY - psy) > 8) pmoved = true; });
    ptrack.addEventListener("pointerup", function (e) {
      if (pmoved) return;
      var slide = e.target.closest(".pdp__slide");
      var img = slide && slide.querySelector("img");
      var lb2 = document.querySelector("[data-lightbox]");
      if (img && lb2) { lb2.querySelector("[data-lightbox-img]").src = img.src; lb2.classList.add("open"); document.body.classList.add("no-scroll"); }
    });
  }

  /* zoom lightbox (desktop main image) */
  var lb = document.querySelector("[data-lightbox]");
  var zoom = root.querySelector("[data-zoom]");
  if (lb && zoom) {
    zoom.addEventListener("click", function () {
      lb.querySelector("[data-lightbox-img]").src = mainImg.src;
      lb.classList.add("open"); document.body.classList.add("no-scroll");
    });
    lb.addEventListener("click", function (e) {
      if (e.target.closest("[data-close-lightbox]") || e.target === lb) { lb.classList.remove("open"); document.body.classList.remove("no-scroll"); }
    });
  }

  /* size guide modal */
  var guide = document.querySelector("[data-sizeguide]");
  var guideBtn = root.querySelector("[data-open-guide]");
  if (guide && guideBtn) {
    guideBtn.addEventListener("click", function () { guide.classList.add("open"); document.body.classList.add("no-scroll"); });
    guide.addEventListener("click", function (e) {
      if (e.target.closest("[data-close-guide]") || e.target === guide) { guide.classList.remove("open"); document.body.classList.remove("no-scroll"); }
    });
  }

  /* sticky add bar */
  var bar = document.querySelector("[data-pdp-bar]");
  if (bar && addBtn) {
    var addOut = false, footIn = false;
    var upd = function () { bar.classList.toggle("show", addOut && !footIn); };
    new IntersectionObserver(function (es) { es.forEach(function (en) { addOut = !en.isIntersecting; }); upd(); }, { rootMargin: "0px 0px -40px 0px" }).observe(addBtn);
    var foot = document.querySelector(".site-footer");
    if (foot) new IntersectionObserver(function (es) { es.forEach(function (en) { footIn = en.isIntersecting; }); upd(); }, { rootMargin: "0px 0px -8% 0px" }).observe(foot);
  }
})();
